module.exports = __webpack_public_path__ + "media/images/sp/specials/common/benefit/benefit_accessary-9c97e87e6e472ff50441ec287eecab4e.jpg";